import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import PopupForm from './PopupForm/PopupForm';
import PopupClosed from './PopupClosed';
export default function Popup(_a) {
    var project = _a.project;
    useEffect(function () {
        document.body.style.overflow = 'hidden';
    }, []);
    console.log('closed', project.closed);
    if (project.closed) {
        return _jsx(PopupClosed, {});
    }
    return _jsx(PopupForm, { project: project });
}
